import classname from "classnames";
import React, { Component } from "react";
import ReactDOM from "react-dom";
import { Link, withRouter } from "react-router-dom";
import { Collapse, Container } from "reactstrap";

//i18n
import { withNamespaces } from "react-i18next";

import { connect } from "react-redux";

class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownStates: {}
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({});
    }
  }

  componentDidMount() {
    var matchingMenuItem = null;
    var ul = document.getElementById("navigation");
    var items = ul.getElementsByTagName("a");
    for (var i = 0; i < items.length; ++i) {
      if (this.props.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      this.activateParentDropdown(matchingMenuItem);
    }
  }

  activateParentDropdown = (item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    if (parent) {
      parent.classList.add("active"); // li
      const parent2 = parent.parentElement;
      parent2.classList.add("active"); // li
      const parent3 = parent2.parentElement;
      if (parent3) {
        parent3.classList.add("active"); // li
        const parent4 = parent3.parentElement;
        if (parent4) {
          parent4.classList.add("active"); // li
          const parent5 = parent4.parentElement;
          if (parent5) {
            parent5.classList.add("active"); // li
            const parent6 = parent5.parentElement;
            if (parent6) {
              parent6.classList.add("active"); // li
            }
          }
        }
      }
    }
    return false;
  };

  toggleDropdown = (dropdownId) => {
    this.setState(prevState => ({
      dropdownStates: {
        ...prevState.dropdownStates,
        [dropdownId]: !prevState.dropdownStates[dropdownId]
      }
    }));
  };

  render() {
    return (
      <React.Fragment>
        {/* Mobile Menu - Rendered outside topnav to avoid overflow issues */}
        {this.props.menuOpen && ReactDOM.createPortal(
          <div 
            className="mobile-menu-overlay"
            style={{
              position: 'fixed',
              top: '70px',
              left: 0,
              right: 0,
              backgroundColor: 'white',
              zIndex: 9999,
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              display: 'block',
              minHeight: '200px',
              width: '100vw',
              height: '100vh'
            }}
          >
            <div style={{
              padding: '20px',
              borderBottom: '1px solid #eee',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <h5 style={{ margin: 0, color: '#333' }}>Menú de Navegación</h5>
              <button 
                onClick={this.props.openLeftMenuCallBack}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '24px',
                  cursor: 'pointer',
                  color: '#666'
                }}
              >
                ✕
              </button>
            </div>
            
            <div style={{ padding: '20px' }}>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                {/* Canales Section */}
                <li style={{ marginBottom: '20px' }}>
                  <div style={{
                    fontSize: '14px',
                    fontWeight: 'bold',
                    color: '#666',
                    marginBottom: '10px',
                    textTransform: 'uppercase'
                  }}>
                    {this.props.t("Canales")}
                  </div>
                  <Link 
                    to="/channel-list" 
                    onClick={this.props.openLeftMenuCallBack}
                    style={{
                      display: 'block',
                      padding: '12px 0',
                      color: '#333',
                      textDecoration: 'none',
                      fontSize: '16px',
                      borderBottom: '1px solid #eee'
                    }}
                  >
                    <i className="ri-list-check me-2"></i>
                    {this.props.t("Canales Registrados")}
                  </Link>
                  <Link 
                    to="/create-channel" 
                    onClick={this.props.openLeftMenuCallBack}
                    style={{
                      display: 'block',
                      padding: '12px 0',
                      color: '#333',
                      textDecoration: 'none',
                      fontSize: '16px',
                      borderBottom: '1px solid #eee'
                    }}
                  >
                    <i className="ri-add-line me-2"></i>
                    {this.props.t("Registrar Nuevo Canal")}
                  </Link>
                </li>

                {/* Certificados Section */}
                <li style={{ marginBottom: '20px' }}>
                  <div style={{
                    fontSize: '14px',
                    fontWeight: 'bold',
                    color: '#666',
                    marginBottom: '10px',
                    textTransform: 'uppercase'
                  }}>
                    {this.props.t("Certificados")}
                  </div>
                  <Link 
                    to="/approval-request-list" 
                    onClick={this.props.openLeftMenuCallBack}
                    style={{
                      display: 'block',
                      padding: '12px 0',
                      color: '#333',
                      textDecoration: 'none',
                      fontSize: '16px',
                      borderBottom: '1px solid #eee'
                    }}
                  >
                    <i className="ri-check-double-line me-2"></i>
                    {this.props.t("Aprobación Solicitudes")}
                  </Link>
                </li>

                {/* Reportes de Solicitudes Section */}
                <li style={{ marginBottom: '20px' }}>
                  <div style={{
                    fontSize: '14px',
                    fontWeight: 'bold',
                    color: '#666',
                    marginBottom: '10px',
                    textTransform: 'uppercase'
                  }}>
                    {this.props.t("Reportes de Solicitudes")}
                  </div>
                  <Link 
                    to="/general-reports-list" 
                    onClick={this.props.openLeftMenuCallBack}
                    style={{
                      display: 'block',
                      padding: '12px 0',
                      color: '#333',
                      textDecoration: 'none',
                      fontSize: '16px',
                      borderBottom: '1px solid #eee'
                    }}
                  >
                    <i className="ri-file-chart-line me-2"></i>
                    {this.props.t("Reportes General")}
                  </Link>
                  <Link 
                    to="/detail-report-list-supplies" 
                    onClick={this.props.openLeftMenuCallBack}
                    style={{
                      display: 'block',
                      padding: '12px 0',
                      color: '#333',
                      textDecoration: 'none',
                      fontSize: '16px',
                      borderBottom: '1px solid #eee'
                    }}
                  >
                    <i className="ri-file-chart-line me-2"></i>
                    {this.props.t("Reporte Detalle Suministro")}
                  </Link>
                  <Link 
                    to="/detail-report-list-teams" 
                    onClick={this.props.openLeftMenuCallBack}
                    style={{
                      display: 'block',
                      padding: '12px 0',
                      color: '#333',
                      textDecoration: 'none',
                      fontSize: '16px',
                      borderBottom: '1px solid #eee'
                    }}
                  >
                    <i className="ri-file-chart-line me-2"></i>
                    {this.props.t("Reporte Detalle Equipos")}
                  </Link>
                  <Link 
                    to="/validate-request" 
                    onClick={this.props.openLeftMenuCallBack}
                    style={{
                      display: 'block',
                      padding: '12px 0',
                      color: '#333',
                      textDecoration: 'none',
                      fontSize: '16px',
                      borderBottom: '1px solid #eee'
                    }}
                  >
                    <i className="ri-check-line me-2"></i>
                    {this.props.t("Validar Solicitud")}
                  </Link>
                </li>

                {/* Oportunidad Section */}
                <li style={{ marginBottom: '20px' }}>
                  <div style={{
                    fontSize: '14px',
                    fontWeight: 'bold',
                    color: '#666',
                    marginBottom: '10px',
                    textTransform: 'uppercase'
                  }}>
                    {this.props.t("Oportunidad")}
                  </div>
                  <Link 
                    to="/opportunity-list-admin" 
                    onClick={this.props.openLeftMenuCallBack}
                    style={{
                      display: 'block',
                      padding: '12px 0',
                      color: '#333',
                      textDecoration: 'none',
                      fontSize: '16px',
                      borderBottom: '1px solid #eee'
                    }}
                  >
                    <i className="ri-list-check me-2"></i>
                    {this.props.t("Lista Oportunidades en Proceso")}
                  </Link>
                  <Link 
                    to="/opportunities-rejected" 
                    onClick={this.props.openLeftMenuCallBack}
                    style={{
                      display: 'block',
                      padding: '12px 0',
                      color: '#333',
                      textDecoration: 'none',
                      fontSize: '16px',
                      borderBottom: '1px solid #eee'
                    }}
                  >
                    <i className="ri-close-circle-line me-2"></i>
                    {this.props.t("Lista Oportunidades Rechazadas")}
                  </Link>
                  <Link 
                    to="/opportunities-approved" 
                    onClick={this.props.openLeftMenuCallBack}
                    style={{
                      display: 'block',
                      padding: '12px 0',
                      color: '#333',
                      textDecoration: 'none',
                      fontSize: '16px',
                      borderBottom: '1px solid #eee'
                    }}
                  >
                    <i className="ri-check-circle-line me-2"></i>
                    {this.props.t("Oportunidades Aprobadas")}
                  </Link>
                  <Link 
                    to="/opportunities-expired" 
                    onClick={this.props.openLeftMenuCallBack}
                    style={{
                      display: 'block',
                      padding: '12px 0',
                      color: '#333',
                      textDecoration: 'none',
                      fontSize: '16px',
                      borderBottom: '1px solid #eee'
                    }}
                  >
                    <i className="ri-time-line me-2"></i>
                    {this.props.t("Oportunidades Caducadas")}
                  </Link>
                  <Link 
                    to="/opportunities-won" 
                    onClick={this.props.openLeftMenuCallBack}
                    style={{
                      display: 'block',
                      padding: '12px 0',
                      color: '#333',
                      textDecoration: 'none',
                      fontSize: '16px',
                      borderBottom: '1px solid #eee'
                    }}
                  >
                    <i className="ri-trophy-line me-2"></i>
                    {this.props.t("Oportunidades Ganadas")}
                  </Link>
                  <Link 
                    to="/opportunities-report" 
                    onClick={this.props.openLeftMenuCallBack}
                    style={{
                      display: 'block',
                      padding: '12px 0',
                      color: '#333',
                      textDecoration: 'none',
                      fontSize: '16px',
                      borderBottom: '1px solid #eee'
                    }}
                  >
                    <i className="ri-file-chart-line me-2"></i>
                    {this.props.t("Report Oportunidades")}
                  </Link>
                  <Link 
                    to="/entity-list" 
                    onClick={this.props.openLeftMenuCallBack}
                    style={{
                      display: 'block',
                      padding: '12px 0',
                      color: '#333',
                      textDecoration: 'none',
                      fontSize: '16px',
                      borderBottom: '1px solid #eee'
                    }}
                  >
                    <i className="ri-building-line me-2"></i>
                    {this.props.t("Entidades registradas")}
                  </Link>
                  <Link 
                    to="/create-entity" 
                    onClick={this.props.openLeftMenuCallBack}
                    style={{
                      display: 'block',
                      padding: '12px 0',
                      color: '#333',
                      textDecoration: 'none',
                      fontSize: '16px',
                      borderBottom: '1px solid #eee'
                    }}
                  >
                    <i className="ri-add-line me-2"></i>
                    {this.props.t("Registrar nueva entidad")}
                  </Link>
                </li>

                {/* Banners Section */}
                <li style={{ marginBottom: '20px' }}>
                  <div style={{
                    fontSize: '14px',
                    fontWeight: 'bold',
                    color: '#666',
                    marginBottom: '10px',
                    textTransform: 'uppercase'
                  }}>
                    {this.props.t("Banners")}
                  </div>
                  <Link 
                    to="/banner-list" 
                    onClick={this.props.openLeftMenuCallBack}
                    style={{
                      display: 'block',
                      padding: '12px 0',
                      color: '#333',
                      textDecoration: 'none',
                      fontSize: '16px',
                      borderBottom: '1px solid #eee'
                    }}
                  >
                    <i className="ri-image-line me-2"></i>
                    {this.props.t("Banners Registrados")}
                  </Link>
                  <Link 
                    to="/create-banner" 
                    onClick={this.props.openLeftMenuCallBack}
                    style={{
                      display: 'block',
                      padding: '12px 0',
                      color: '#333',
                      textDecoration: 'none',
                      fontSize: '16px',
                      borderBottom: '1px solid #eee'
                    }}
                  >
                    <i className="ri-add-line me-2"></i>
                    {this.props.t("Registrar Nuevo Banner")}
                  </Link>
                </li>

                {/* Configurador Section */}
                <li style={{ marginBottom: '20px' }}>
                  <div style={{
                    fontSize: '14px',
                    fontWeight: 'bold',
                    color: '#666',
                    marginBottom: '10px',
                    textTransform: 'uppercase'
                  }}>
                    {this.props.t("Configurador")}
                  </div>
                  <Link 
                    to="/configurator-list-admin" 
                    onClick={this.props.openLeftMenuCallBack}
                    style={{
                      display: 'block',
                      padding: '12px 0',
                      color: '#333',
                      textDecoration: 'none',
                      fontSize: '16px',
                      borderBottom: '1px solid #eee'
                    }}
                  >
                    <i className="ri-file-chart-line me-2"></i>
                    {this.props.t("Reporte de configuraciones")}
                  </Link>
                  <Link 
                    to="/configurator-list-channel" 
                    onClick={this.props.openLeftMenuCallBack}
                    style={{
                      display: 'block',
                      padding: '12px 0',
                      color: '#333',
                      textDecoration: 'none',
                      fontSize: '16px',
                      borderBottom: '1px solid #eee'
                    }}
                  >
                    <i className="ri-list-check me-2"></i>
                    {this.props.t("Lista Configuraciones por canal")}
                  </Link>
                  <Link 
                    to="/configurator-items-list" 
                    onClick={this.props.openLeftMenuCallBack}
                    style={{
                      display: 'block',
                      padding: '12px 0',
                      color: '#333',
                      textDecoration: 'none',
                      fontSize: '16px',
                      borderBottom: '1px solid #eee'
                    }}
                  >
                    <i className="ri-list-check me-2"></i>
                    {this.props.t("Ver Listas de productos Completas")}
                  </Link>
                  <Link 
                    to="/configurator-items-create" 
                    onClick={this.props.openLeftMenuCallBack}
                    style={{
                      display: 'block',
                      padding: '12px 0',
                      color: '#333',
                      textDecoration: 'none',
                      fontSize: '16px',
                      borderBottom: '1px solid #eee'
                    }}
                  >
                    <i className="ri-upload-line me-2"></i>
                    {this.props.t("Cargar Lista Completa del Configurador")}
                  </Link>
                  <Link 
                    to="/configurator-notes-list" 
                    onClick={this.props.openLeftMenuCallBack}
                    style={{
                      display: 'block',
                      padding: '12px 0',
                      color: '#333',
                      textDecoration: 'none',
                      fontSize: '16px',
                      borderBottom: '1px solid #eee'
                    }}
                  >
                    <i className="ri-list-check me-2"></i>
                    {this.props.t("Lista de Notas")}
                  </Link>
                  <Link 
                    to="/configurator-notes-create" 
                    onClick={this.props.openLeftMenuCallBack}
                    style={{
                      display: 'block',
                      padding: '12px 0',
                      color: '#333',
                      textDecoration: 'none',
                      fontSize: '16px',
                      borderBottom: '1px solid #eee'
                    }}
                  >
                    <i className="ri-add-line me-2"></i>
                    {this.props.t("Crear Nota")}
                  </Link>
                </li>

                {/* Catálogo Electrónico Section */}
                <li style={{ marginBottom: '20px' }}>
                  <div style={{
                    fontSize: '14px',
                    fontWeight: 'bold',
                    color: '#666',
                    marginBottom: '10px',
                    textTransform: 'uppercase'
                  }}>
                    {this.props.t("Catálogo Electrónico")}
                  </div>
                  <Link 
                    to="/catalogo-electronico-reporte" 
                    onClick={this.props.openLeftMenuCallBack}
                    style={{
                      display: 'block',
                      padding: '12px 0',
                      color: '#333',
                      textDecoration: 'none',
                      fontSize: '16px',
                      borderBottom: '1px solid #eee'
                    }}
                  >
                    <i className="ri-file-chart-line me-2"></i>
                    {this.props.t("Reporte General")}
                  </Link>
                  <Link 
                    to="/catalogo-electronico-estadisticas" 
                    onClick={this.props.openLeftMenuCallBack}
                    style={{
                      display: 'block',
                      padding: '12px 0',
                      color: '#333',
                      textDecoration: 'none',
                      fontSize: '16px',
                      borderBottom: '1px solid #eee'
                    }}
                  >
                    <i className="ri-bar-chart-line me-2"></i>
                    {this.props.t("Estadísticas")}
                  </Link>
                </li>
              </ul>
            </div>
          </div>,
          document.body
        )}
        
        <div className="topnav">
          <Container fluid>
            <nav 
              className="navbar navbar-light navbar-expand-lg topnav-menu"
              id="navigation"
            >
              <Collapse
                isOpen={true}
                className="navbar-collapse d-none d-lg-block"
                id="topnav-menu-content"
              >
                <ul className="navbar-nav">
                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none"
                      to="/#"
                      id="topnav-canales"
                      role="button"
                      onClick={(e) => {
                        e.preventDefault();
                        this.toggleDropdown('canales');
                      }}
                    >
                      <i className="ri-apps-2-line me-2"></i>{" "}
                      {this.props.t("Canales")}{" "}
                      <div className="arrow-down"></div>
                    </Link>
                    <div
                      className={classname("dropdown-menu dropdown-menu-end", {
                        show: this.state.dropdownStates.canales,
                      })}
                      aria-labelledby="topnav-canales"
                    >
                      <Link to="/channel-list" className="dropdown-item">
                        {this.props.t("Canales Registrados")}
                      </Link>
                      <Link to="/create-channel" className="dropdown-item">
                        {this.props.t("Registrar Nuevo Canal")}
                      </Link>
                    </div>
                  </li>

                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none"
                      to="/#"
                      id="topnav-uielement"
                      role="button"
                      onClick={(e) => {
                        e.preventDefault();
                        this.toggleDropdown('certificados');
                      }}
                    >
                      <i className="ri-pencil-ruler-2-line me-2"></i>
                      {this.props.t("Certificados")}{" "}
                      <div className="arrow-down"></div>
                    </Link>

                    <div
                      className={classname("dropdown-menu dropdown-menu-end", {
                        show: this.state.dropdownStates.certificados,
                      })}
                      aria-labelledby="topnav-canales"
                    >
                      <Link
                        to="/approval-request-list"
                        className="dropdown-item"
                      >
                        {this.props.t("Aprobación Solicitudes")}
                      </Link>
                    </div>
                  </li>

                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none"
                      to="/#"
                      id="topnav-apps"
                      role="button"
                      onClick={(e) => {
                        e.preventDefault();
                        this.toggleDropdown('reportes');
                      }}
                    >
                      <i className="ri-apps-2-line me-2"></i>
                      {this.props.t("Reportes de Solicitudes")}{" "}
                      <div className="arrow-down"></div>
                    </Link>

                    <div
                      className={classname("dropdown-menu dropdown-menu-end", {
                        show: this.state.dropdownStates.reportes,
                      })}
                      aria-labelledby="topnav-canales"
                    >
                      <Link
                        to="/general-reports-list"
                        className="dropdown-item"
                      >
                        {this.props.t("Reportes General")}
                      </Link>
                      <Link
                        to="/detail-report-list-supplies"
                        className="dropdown-item"
                      >
                        {this.props.t("Reporte Detalle Suministro")}
                      </Link>
                      <Link
                        to="/detail-report-list-teams"
                        className="dropdown-item"
                      >
                        {this.props.t("Reporte Detalle Equipos")}
                      </Link>
                      <Link to="/validate-request" className="dropdown-item">
                        {this.props.t("Validar Solicitud")}
                      </Link>
                    </div>
                  </li>

                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none"
                      to="/#"
                      id="topnav-apps"
                      role="button"
                      onClick={(e) => {
                        e.preventDefault();
                        this.toggleDropdown('oportunidad');
                      }}
                    >
                      <i className="ri-apps-2-line me-2"></i>
                      {this.props.t("Oportunidad")}{" "}
                      <div className="arrow-down"></div>
                    </Link>

                    <div
                      className={classname("dropdown-menu dropdown-menu-end", {
                        show: this.state.dropdownStates.oportunidad,
                      })}
                      aria-labelledby="topnav-canales"
                    >
                      <Link
                        to="/opportunity-list-admin"
                        className="dropdown-item"
                      >
                        {this.props.t("Lista Oportunidades en Proceso")}
                      </Link>
                      <Link
                        to="/opportunities-rejected"
                        className="dropdown-item"
                      >
                        {this.props.t("Lista Oportunidades Rechazadas")}
                      </Link>
                      <Link
                        to="/opportunities-approved"
                        className="dropdown-item"
                      >
                        {this.props.t("Oportunidades Aprobadas")}
                      </Link>
                      <Link
                        to="/opportunities-expired"
                        className="dropdown-item"
                      >
                        {this.props.t("Oportunidades Caducadas")}
                      </Link>
                      <Link to="/opportunities-won" className="dropdown-item">
                        {this.props.t("Oportunidades Ganadas")}
                      </Link>
                      <Link
                        to="/opportunities-canceled"
                        className="dropdown-item"
                      >
                        {this.props.t("Oportunidades Canceladas")}
                      </Link>
                      <Link
                        to="/opportunities-report"
                        className="dropdown-item"
                      >
                        {this.props.t("Reporte Oportunidades")}
                      </Link>
                      <Link to="/entity-list" className="dropdown-item">
                        {this.props.t("Entidades registradas")}
                      </Link>
                      <Link to="/create-entity" className="dropdown-item">
                        {this.props.t("Registrar nueva entidad")}
                      </Link>
                    </div>
                  </li>

                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none"
                      to="/#"
                      id="topnav-banners"
                      role="button"
                      onClick={(e) => {
                        e.preventDefault();
                        this.toggleDropdown('banners');
                      }}
                    >
                      <i className="ri-apps-2-line me-2"></i>{" "}
                      {this.props.t("Banners")}{" "}
                      <div className="arrow-down"></div>
                    </Link>
                    <div
                      className={classname("dropdown-menu dropdown-menu-end", {
                        show: this.state.dropdownStates.banners,
                      })}
                      aria-labelledby="topnav-canales"
                    >
                      <Link to="/banner-list" className="dropdown-item">
                        {this.props.t("Banners Registrados")}
                      </Link>
                      <Link to="/create-banner" className="dropdown-item">
                        {this.props.t("Registrar Nuevo Banner")}
                      </Link>
                    </div>
                  </li>

                  {(
                    <li className="nav-item dropdown">
                      <Link
                        className="nav-link dropdown-toggle arrow-none"
                        to="/#"
                        id="topnav-apps"
                        role="button"
                        onClick={(e) => {
                          e.preventDefault();
                          this.toggleDropdown('configurador');
                        }}
                      >
                        <i className="ri-apps-2-line me-2"></i>
                        {this.props.t("Configurador")}{" "}
                        <div className="arrow-down"></div>
                      </Link>

                      <div
                        className={classname(
                          "dropdown-menu dropdown-menu-end",
                          {
                            show: this.state.dropdownStates.configurador,
                          }
                        )}
                        aria-labelledby="topnav-canales"
                      >
                        <Link
                          to="/configurator-list-admin"
                          className="dropdown-item"
                        >
                          {this.props.t("Reporte de configuraciones")}
                        </Link>
                        <Link
                          to="/configurator-list-channel"
                          className="dropdown-item"
                        >
                          {this.props.t("Lista Configuraciones por canal")}
                        </Link>
                        <Link
                          to="/configurator-items-list"
                          className="dropdown-item"
                        >
                          {this.props.t("Ver Listas de productos Completas")}
                        </Link>
                        <Link
                          to="/configurator-items-create"
                          className="dropdown-item"
                        >
                          {this.props.t(
                            "Cargar Lista Completa del Configurador"
                          )}
                        </Link>
                        <Link
                          to="/configurator-notes-list"
                          className="dropdown-item"
                        >
                          {this.props.t("Lista de Notas")}
                        </Link>
                        <Link
                          to="/configurator-notes-create"
                          className="dropdown-item"
                        >
                          {this.props.t("Crear Nota")}
                        </Link>
                      </div>
                    </li>
                  )}

                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none"
                      to="/#"
                      id="topnav-apps"
                      role="button"
                      onClick={(e) => {
                        e.preventDefault();
                        this.toggleDropdown('catalogo');
                      }}
                    >
                      <i className="ri-apps-2-line me-2"></i>
                      {this.props.t("Catálogo Electrónico")}{" "}
                      <div className="arrow-down"></div>
                    </Link>

                    <div
                      className={classname("dropdown-menu dropdown-menu-end", {
                        show: this.state.dropdownStates.catalogo,
                      })}
                      aria-labelledby="topnav-canales"
                    >
                      <Link
                        to="/catalogo-electronico-reporte"
                        className="dropdown-item"
                      >
                        {this.props.t("Reporte General")}
                      </Link>
                      <Link
                        to="/catalogo-electronico-estadisticas"
                        className="dropdown-item"
                      >
                        {this.props.t("Estadísticas")}
                      </Link>
                    </div>
                  </li>
                </ul>
              </Collapse>
            </nav>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { leftSideBarType, leftSideBarTheme } = state.Layout;
  return { leftSideBarType, leftSideBarTheme };
};

export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(Navbar))
);
